import { getProductWithVariants, ProductWithVariants } from '@models/product';
import { defaultContractWidgets } from '../../../config/default-contract-widgets';
import { SingleInsurantWidgetComponent } from '../../../customer-portal/widgets/single-insurant-widget/single-insurant-widget.component';
import { InsuredBikeWidgetComponent } from '../widgets/insured-bike-widget/insured-bike-widget.component';

export const bikeProduct: ProductWithVariants = getProductWithVariants({
    slug: 'schueler-fahrrad-versicherung',
    title: 'Schüler-Fahrrad-Versicherung',
    fullTitle: 'Schüler-Fahrrad-Versicherung',
    insuranceTypeName: 'Schüler Fahrrad 2020',
    insuranceTypeId: 23,
    legacy: true,
    portalConfig: {
        icon: 'bike-2',
        widgets: [
            ...defaultContractWidgets,
            { component: SingleInsurantWidgetComponent },
            { component: InsuredBikeWidgetComponent },
        ],
    },
});
